import { FleetActions } from '../actions';

export const fleet = (state = null, action) => {
  switch (action.type) {
    case FleetActions.FETCHING_TRACKERS:
      return Object.assign({}, state, { trackers: { fetching: true }});
    case FleetActions.TRACKERS_RECEIVED:
      return Object.assign({}, state, { trackers: { fetching: false, list: action.trackers }});
    case FleetActions.TRACKER_RECEIVED:
      return Object.assign({}, state, { tracker: action.tracker });
    case FleetActions.FETCHING_UNITS:
      return Object.assign({}, state, { units: { fetching: true }});
    case FleetActions.UNITS_RECEIVED:
      return Object.assign({}, state, { units: { fetching: false, list: action.units }});
    case FleetActions.FETCHING_TRAILERS:
      return Object.assign({}, state, { trailers: { fetching: true }});
    case FleetActions.TRAILERS_RECEIVED:
      return Object.assign({}, state, { trailers: { fetching: false, list: action.trailers }});
    default:
      return state;
  } 
}

export default fleet;



// WEBPACK FOOTER //
// ./src/reducers/fleet.js